import { EmployeeUser, UserId } from 'types';
import { employeeUserFields } from 'consts/tables/employee/employeeUserFields';

export const findEmployeeIdByUserId = (userId: UserId, employees: EmployeeUser[]) => {
    const foundEmployee = employees.find(
        (employee) => employee[employeeUserFields.userId] === userId,
    );
    return foundEmployee?.[employeeUserFields.employeeId];
};
